angular.module('trainerWebApp.resources').factory('flexAngularProxy', ['feedbackResource', 'deleteSeriesResource', '$window', 'courseTraineesResource', 'checkDnsResource', '$rootScope', '$location', '$timeout',
  function(feedbackResource, deleteSeriesResource, $window, courseTraineesResource, checkDnsResource, $rootScope, $location, $timeout) {

    function defaultResultHandler(token) {
      return function() {
        MF.getFlexApp().flexProxyCallback(token, false);
      }
    }

    function defaultErrorHandler(token) {
      return function(error) {
        var flexError = {errorCode: error.status, details: error.data, message: "server error", code: error.status};
        MF.getFlexApp().flexProxyCallback(token, true, flexError);
        return "cancelDefault";
      }
    }

    function sendFeedback(token, text, popupName) {
      var location = "Flex";
      if(popupName && popupName.length > 0) {
        location += " - " + popupName;
      }
      feedbackResource.send(text,
        location,
        defaultResultHandler(token),
        defaultErrorHandler(token));
    }

    function deleteSeries(token, seriesId) {
      deleteSeriesResource.send(seriesId,
        defaultResultHandler(token),
        defaultErrorHandler(token));
    }

    function resetCourse(token, courseId, traineeIds) {
      var date = new Date();
      var dateString = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      courseTraineesResource.retakeCourse(courseId, traineeIds, dateString,
        defaultResultHandler(token),
        defaultErrorHandler(token));
    }

    function checkDns(token, domainName) {
      checkDnsResource.send(domainName,
        function(res) {
          MF.getFlexApp().flexProxyCallback(token, false, {success: res.success, domainName: domainName});
        },
        defaultErrorHandler(token));
    }

    function enableAdvancedTierTrial() {
      $rootScope.$broadcast('advancedTierTrialRequestedEvent');
    }

    function changeUrl(value) {
      // need to get it in digest if coming from flex
      $timeout(function() {
        $location.path(value);
      });
    }

    function refreshLogo() {
      try {
        MF.getFlexApp().sendToFlexApp("refreshLogo");
      } catch(e) {
        console.log('function unavailable');
      }
    }

    function setup() {
      $window.MF.flexAngularProxy = {
        sendFeedback: sendFeedback,
        deleteSeries: deleteSeries,
        resetCourse: resetCourse,
        checkDns: checkDns,
        enableAdvancedTierTrial: enableAdvancedTierTrial,
        changeUrl: changeUrl,
        refreshLogo: refreshLogo
      };
    }

    return {
      setup: setup
    };
  }
]);
